import React from 'react';
import { Link } from 'react-router-dom';
import { MdVisibility, MdEmail, MdPhone, MdLocationOn } from 'react-icons/md';
import { FaFacebookF, FaTwitter, FaInstagram, FaLinkedinIn } from 'react-icons/fa';

// ✅ ADD THESE IMPORTS
import mainLogo from '../assets/nethraloka.png';
import leoLogo from '../assets/logo.png';

const Footer = () => {
  return (
    <footer className="bg-black border-t border-white/10 pt-20 pb-10">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-20">
          
          {/* Brand Column */}
          <div className="space-y-8">
            <Link to="/" className="flex items-center gap-3">
              
              {/* 🔥 REPLACED ICON WITH LOGO */}
              <img
                src={mainLogo}
                alt="VisionCarePlus"
                className="h-10 object-contain"
              />

              <span className="font-extrabold text-xl tracking-tight text-white">
                VisionCare<span className="text-[var(--gold-primary)]">Plus</span>
              </span>
            </Link>

            <p className="text-sm leading-relaxed text-slate-400 font-medium">
              Transforming eye care through digital innovation. We provide professional guidance and screening tools to protect your most precious sense.
            </p>

            <div className="flex gap-3">
              {[FaFacebookF, FaTwitter, FaInstagram, FaLinkedinIn].map((Icon, idx) => (
                <a 
                  key={idx} 
                  href="#!" 
                  className="w-10 h-10 rounded-xl bg-white/5 border border-white/10 flex items-center justify-center text-slate-400 hover:bg-[var(--gold-primary)] hover:text-black hover:border-[var(--gold-primary)] transition-all duration-300"
                >
                  <Icon size={16} />
                </a>
              ))}
            </div>
          </div>

          {/* Quick Links */}
          <div className="space-y-8">
            <h4 className="text-[var(--gold-primary)] font-bold uppercase tracking-widest text-xs">Services</h4>
            <ul className="space-y-4">
              {['Tele-Consultation', 'Online Vision Test', 'Post-Surgery Follow-up', 'Find Help'].map((item) => (
                <li key={item}>
                  <Link 
                    to={`/${item.toLowerCase().replace(/ /g, '-')}`} 
                    className="text-sm font-semibold text-slate-400 hover:text-[var(--gold-primary)] transition-colors flex items-center gap-2 group"
                  >
                    <span className="w-1.5 h-1.5 rounded-full bg-white/10 group-hover:bg-[var(--gold-primary)] transition-colors" />
                    {item}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact Info */}
          <div className="space-y-8">
            <h4 className="text-[var(--gold-primary)] font-bold uppercase tracking-widest text-xs">Contact</h4>
            <ul className="space-y-5">
              {[
                { icon: MdLocationOn, text: 'Leo Club of SLIIT, Malabe' },
                { icon: MdPhone, text: '+94 78 633 6363' },
                { icon: MdEmail, text: 'info@sliitleo.org' }
              ].map((item, idx) => (
                <li key={idx} className="flex items-start gap-4">
                  <div className="w-8 h-8 rounded-lg bg-white/5 flex items-center justify-center text-[var(--gold-primary)] flex-shrink-0 border border-white/10">
                    <item.icon size={18} />
                  </div>
                  <span className="text-sm font-semibold text-slate-400 leading-snug">{item.text}</span>
                </li>
              ))}
            </ul>
          </div>

          {/* Legal/Disclaimer Column */}
          <div className="space-y-8">
            <h4 className="text-[var(--gold-primary)] font-bold uppercase tracking-widest text-xs">Legal</h4>
            <div className="p-5 bg-white/5 border border-white/10 rounded-xl">
              <p className="text-[11px] leading-relaxed text-slate-500 font-medium italic">
                <strong>Important:</strong> This platform provides general screening and preliminary guidance. It is NOT a medical diagnosis. Always consult a certified professional for any eye health concerns.
              </p>
            </div>
          </div>
        </div>

        <div className="pt-10 border-t border-white/10 flex flex-col md:flex-row justify-between items-center gap-6">
          
          {/* 🔻 LEFT SIDE */}
          <div className="flex flex-col items-center md:items-start gap-2">

            {/* 🔥 ADD LEO LOGO */}
            <img
              src={leoLogo}
              alt="Leo Club"
              className="h-10 object-contain mb-1"
            />

            <p className="text-xs font-bold text-slate-500 tracking-wide uppercase">
              © {new Date().getFullYear()} VISIONCAREPLUS. EXCELLENCE IN EYE HEALTH.
            </p>

            <p className="text-[10px] font-black text-[var(--gold-primary)]/60 uppercase tracking-[0.2em]">
              Developed by Leo Club of SLIIT IT Department
            </p>

            {/* 🔥 ADD THIS LINE */}
            <p className="text-[10px] text-slate-500 uppercase tracking-wide">
              All Rights Reserved
            </p>
          </div>

          {/* RIGHT SIDE */}
          <div className="flex gap-8">
            <Link to="/privacy-policy" className="text-xs font-bold text-slate-500 hover:text-[var(--gold-primary)] tracking-wide uppercase">Privacy Policy</Link>
            <Link to="/terms-of-service" className="text-xs font-bold text-slate-500 hover:text-[var(--gold-primary)] tracking-wide uppercase">Terms of Service</Link>
          </div>
        </div>

      </div>
    </footer>
  );
};

export default Footer;